// ES6 syntax to extend jQuery with plugins
let $ = require('jquery');
require('jquery-date-range-picker');
//

import moment from 'moment';

$(document).ready(function() {
  const $calendars = $('.e-calendar');

  $calendars.each(function() {
    const $thisCalendar = $(this);
    const $input = $thisCalendar.find('input');

    $input.dateRangePicker({
      language: 'es',
      autoClose: true,
      singleMonth: true,
    	showShortcuts: false,
    	showTopbar: false,
    	container: $thisCalendar[0],
      endDate: new Date(),
      startOfWeek: 'monday'
    }).bind('datepicker-change', function() {
      $input.change();
    }).data('dateRangePicker').resetMonthsView(moment());
  });
});



// WEBPACK FOOTER //
// ./app/ui/elements/calendar/index.js